import { render } from "./ModalUpdateDocument.vue?vue&type=template&id=4fedc576&scoped=true"
import script from "./ModalUpdateDocument.vue?vue&type=script&lang=js"
export * from "./ModalUpdateDocument.vue?vue&type=script&lang=js"

import "./ModalUpdateDocument.vue?vue&type=style&index=0&id=4fedc576&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fedc576"]])

export default __exports__